import {get, writable} from "svelte/store";

type PartialRecord<K extends keyof any, T> = {
    [P in K]?: T;
};

export enum CustomizationEvent {
    Products = "upsell-cross-sell-products",
}

export const Hooks = writable<PartialRecord<CustomizationEvent, unknown>>({});

export function registerHook(type: CustomizationEvent, callback: unknown) {
    if (!isValidHook(type)) {
        console.error(`%chook: ${type} is not a valid customization hook!`, 'font-weight: bold;');
        return;
    }

    if (!callback && get(Hooks)[type]) {
        //delete callback
        Hooks.update(old => {
            return Object.entries(old).reduce((previousValue, currentValue) => {
                if (currentValue[0] !== type) {
                    return {
                        ...previousValue,
                        [currentValue[0]]: currentValue[1]
                    }
                }
                return previousValue;
            }, {})
        });

        console.log(`Fast Upsell-Cross-Sell: ${type} hook %cdeleted%c!`, 'font-weight: bold;', '');

        return true;
    }

    if (!callback) {
        return false;
    }

    Hooks.update((old) => ({
        ...old,
        [type]: callback
    }));

    console.log(`Fast Upsell-Cross-Sell: ${type} hook %cregistered%c!`, 'font-weight: bold;', '');

    return true;
}


function isValidHook(type: CustomizationEvent) {
    for (const key of Object.values(CustomizationEvent)) {
        if (type === key) {
            return true;
        }
    }

    return false;
}